// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Tooltip/Warmup.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Button, Tooltip } from '@sail/ui';
export const Warmup = () => <>
    <Tooltip trigger={<Button onPress={undefined}>Hover me</Button>}>
      I showed up after a delay.
    </Tooltip>

    <Tooltip trigger={<Button onPress={undefined}>Then me</Button>}>
      I showed up immediately.
    </Tooltip>
  </>;